/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */
import * as MsDyn365 from '@msdyn365-commerce/core';

import * as React from 'react';

import { IEcommPageTitleProps } from './ecomm-page-title.props.autogenerated';

export interface IEcommPageTitleViewProps extends IEcommPageTitleProps<{}> {
    title?: React.ReactNode;
    enablePrimaryColour: boolean;
    className: string;
    TitleStyle: string;
    TitlePrimaryColour: string;
}

/**
 *
 * EcommPageTitle component
 */
class EcommPageTitle extends React.PureComponent<IEcommPageTitleProps<{}>> {
  public render(): JSX.Element | null {
    const { config } = this.props;

    const text = config.title && <MsDyn365.RichTextComponent text={config.title} editProps={{onEdit: this._handleTextChange, requestContext:this.props.context.request}} />;

    let userStyle = config.className ? config.className : ' ';

    const PageTitleViewProps = {
      ...this.props,
      title: text,
      enablePrimaryColour: config.enablePrimaryColour,
      className: userStyle,
      TitleStyle: 'ecomm-page-title',
      TitlePrimaryColour: 'ecomm-page-title enable-primary-colour'
    };

    return this.props.renderView(PageTitleViewProps) as React.ReactElement;
  }

  private _handleTextChange = (event: MsDyn365.ContentEditableEvent) => this.props.config.title = event.target.value;
}
export default EcommPageTitle;
